module.exports = __webpack_public_path__ + "img/bianji.09211f1f.png";